// extracted by mini-css-extract-plugin
export var active = "_1j-7";
export var container = "_1j-0";
export var evenWidth = "_1j-4";
export var large = "_1j-5";
export var outlet = "_1j-8";
export var slide = "_1j-2";
export var small = "_1j-6";
export var tab = "_1j-3";
export var tabs = "_1j-1";